import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createCsrfToken, createHeaders, fetchJsonQuery } from "@mne-core/api";

import AuthenticationURI from "./AuthenticationURIBuilder";

export interface ILogoutOpts extends RequestInit {
  apiUrl: string;
  apikey?: string;
  sessionKey: string;
  ctrl?: QueryController;
}

export const createRequest = (opts: ILogoutOpts): Request => {
  const { apiUrl, apikey, sessionKey, ...restOpts } = opts;
  const url = new AuthenticationURI().setApiUrl(apiUrl).setSegment("logout");

  const headers = createHeaders({
    /* If the apikey is something else then undefined its added */
    "ARGUS-API-KEY": apikey,
    "Argus-CSRF-Token": !apikey ? createCsrfToken(sessionKey, url.toString()) : false,
  });

  let localRequestOpts: RequestInit = {
    headers,
    method: "DELETE",
    mode: "cors",
  };

  if (!apikey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }

  return new Request(String(url), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function logout(opts: ILogoutOpts): Promise<JsonQuery<IResultstash<object>>> {
  return await fetchJsonQuery<IResultstash<object>>(createRequest(opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default logout;
